import { render } from "./AppDropdown.vue?vue&type=template&id=c516ae3c&scoped=true"
import script from "./AppDropdown.vue?vue&type=script&lang=js"
export * from "./AppDropdown.vue?vue&type=script&lang=js"

import "./AppDropdown.vue?vue&type=style&index=0&id=c516ae3c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c516ae3c"]])

export default __exports__